<template>
  <div class="containerBox">
    <img
      src="@/assets/image/xplan/analysisText.png"
      class="title wow animate__animated durationTime animate__fadeInUp"
      alt=""
    />
    <div class="content">
      <div class="lf">
        <div class="item"></div>
        <div class="item">
          投资模式
        </div>
        <div class="item">
          补贴力度
        </div>
        <div class="item hasTipItem">
          客服和运维费
          <div class="tip">* 不含现场运维费用</div>
        </div>
        <div class="item">
          回本周期保证
        </div>
        <div class="item">
          设备保回收
        </div>
      </div>
      <div class="center">
        <div class="item">
          前10所PLUS特权
        </div>
        <div class="item">
          <div class="zeroAnalysis">
            0风险
          </div>
          先收益后投资
        </div>
        <div class="item">
          单独百万补贴
        </div>
        <div class="item">
          合约期全免
        </div>
        <div class="item">
          9个月～一年
        </div>
        <div class="item">
          按年30%折旧
        </div>
      </div>
      <div class="rg">
        <div class="item">
          前100所特权
        </div>
        <div class="item">
          先投资后收益
        </div>
        <div class="item">
          总体千万补贴
        </div>
        <div class="item">
          前两年全免
        </div>
        <div class="item">
          一年～15个月
        </div>
        <div class="item">
          按年40%折旧
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";

export default {
  data() {
    return {};
  },
  computed: {},
  mounted() {
    // init wow
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true //异步加载的内容是否有效
    });
    wow.init();
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.containerBox {
  width: 100%;
  padding: 1rem 0;
  background: url(../../../assets/image/xplan/analysisBg1.png) center no-repeat;
  background-size: cover;
  .title {
    width: 12.27rem;
    height: auto;
    margin: 0 auto 0.8rem;
    display: block;
  }
  .content {
    width: 14.84rem;
    border-radius: 0.2rem;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    > div {
      border-right: 0.01rem solid #707070;
      &:last-child {
        border-right: 0;
      }
      .item {
        height: 1.32rem;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.3rem;
        color: #eddcb9;
        background-color: rgba($color: #bf0000, $alpha: 0.53);
        &:nth-child(2n) {
          color: #ad1515;
          background: linear-gradient(180deg, #e3c99f 0%, #fffde5 100%);
        }
        &:nth-child(1) {
          font-weight: 500;
        }
      }
      .hasTipItem {
        display: flex;
        flex-direction: column;
        .tip {
          font-size: 0.18rem;
          padding-top: 0.08rem;
          font-weight: 400;
        }
      }
      .zeroAnalysis {
        padding: 0 0.26rem;
        line-height: 0.5rem;
        background: #dbe002;
        box-shadow: 0rem 0.03rem 0.06rem 0.01rem rgba(0, 0, 0, 0.16);
        border-radius: 0.25rem;
        color: #000;
        font-size: 0.26rem;
        position: absolute;
        left: 0.58rem;
      }
    }
    .lf {
      width: 3.4rem;
      .item {
        font-weight: 500;
      }
    }
    .center {
      flex: 1;
    }
    .rg {
      flex: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/xplan/components/privilegeAnalysis.vue